export default __webpack_public_path__ + "static/whowatch_soundlogo-65fdbcfd5341aa45d10c22c27ed19108.mp4";